// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_E7Amw","title":"title_te3DA","address-wrap":"address-wrap_ff0-v","address":"address_WDwJq"};